import type { StatusTone } from './StatusChip';
import type { TrackingStatus } from '@/types/api';

/**
 * A vehicle's live tracking status, one table for the map and the vehicles
 * list (which may not import the tracking feature). `UNKNOWN` and `OFFLINE`
 * are **different problems for different people** and must never share a
 * look: `UNKNOWN` is *our* feed being down — the van may be fine and nothing
 * about it is known — so it gets no colour at all; `OFFLINE` is the *van*
 * gone quiet past its window, which is a fact about the van and is red.
 */
export const TRACKING_STATUS_TONES: Record<TrackingStatus, StatusTone> = {
  MOVING: 'active',
  IDLE: 'warning',
  STOPPED: 'info',
  OFFLINE: 'danger',
  UNKNOWN: 'neutral',
  NO_DATA: 'neutral',
  NO_TRACKER: 'neutral',
};
